export const appName = 'users';

export const adminRoles = ['admin', 'aluemyyntijohtaja'];
